import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";
import ImageResize from "quill-image-resize-module-react";

// Register the image resize module
Quill.register("modules/imageResize", ImageResize);

const TextEditor = ({ description, value, setValue, editId }) => {
 
  // Define custom modules and toolbar
  const modules = {
    toolbar: editId ? null : [
      // [{ header: "1" }, { header: "2" }, { font: [] }],
      // [{ size: [] }],
      // [{ color: [] }, { background: [] }], // Add background color option
      ["bold", "italic", "underline", "strike"], //, "blockquote"
      [{ list: "ordered" }, { list: "bullet" }],
      // ["link"],
     
      // ["clean"], // Remove formatting button
      // [{ align: [] }],
    ],
    imageResize: {
      displaySize: true,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "color",
    "background",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "align",
  ];
  const handleChange = (content) => {
    // If content is just <p><br></p>, set to empty string
    const trimmedContent = content.trim();
    if (trimmedContent === "<p><br></p>" || trimmedContent === "") {
      setValue("");
    } else {
      setValue(content);
    }
  };
  return (
    <div>
      <ReactQuill
        readOnly={editId}
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={description}
        className={editId ? 'disabledClass' : null}
      />
    </div>
  );
};

export default TextEditor;